export default __webpack_public_path__ + "static/media/Picocef-70-ml-ban.84411673.jpg";